import Swal from 'sweetalert2'
import { colors } from '../../constants/colors'
import { alertIcons } from '../../assets/icons/icons'
import './swal.stye.css';

type sweetAlertIconType = {
    error: 'error';
    question: 'question',
    info: 'info',
    success: 'success',
    warning: 'warning'
}

export function swalSuccess(title?: string, option?: string, url?: any, callback?: any) {
    Swal.fire({
        icon: 'success',
        title: title,
        confirmButtonColor: colors.themeMainColor
    }).then((value) => {
        if (option === 'reset') {
        } else if (option === 'reload') {
            window.location.reload()
        } else if (option === 'go') {
            window.location.href = url
        } else if (callback != null) {
            value.isConfirmed && callback(true)
        }
    })
}

export const alertSuccess = (title: string, detail?: string, confirmButtonText?: string, callback?: () => void, cancelButtonText?: string) => {
    Swal.fire({
        title: title,
        text: detail,
        confirmButtonColor: colors.complete,
        confirmButtonText: confirmButtonText || 'ตกลง',
        cancelButtonText,
        showCancelButton: !!cancelButtonText,
        customClass: {
            popup: 'custom-alert-sweet',
            icon: 'no-border',
            confirmButton: "custom-alert-confirm-button",
            title: "custom-alert-title",
            cancelButton: "custom-alert-cancel-button",
        },
        iconHtml: `<img width={150} height={150} src="${alertIcons.successAlert}" alt="alert-success" />`
    }).then((result) => {
        if (result.isConfirmed) {
            callback && callback();
        }
        return false
    })
}
export const alertError = (title: string, detail?: string, confirmButtonText?: string, callback?: () => void, is_html?: boolean) => {
    Swal.fire({
        title: title,
        ...(is_html ? {
            html: detail
        } : {
            text: detail
        }),
        confirmButtonColor: colors.danger,
        confirmButtonText: confirmButtonText || 'ตกลง',
        customClass: {
            popup: 'custom-alert-sweet',
            icon: 'no-border',
            confirmButton: "custom-alert-error-confirm-button",
            title: "custom-alert-title",
        },
        iconHtml: `<img width={150} height={150} src="${alertIcons.errorAlert}" alt="alert-error" />`
    }).then((result) => {
        if (result.isConfirmed) {
            callback && callback();
        }
        return false
    })
}
type ExtraButton = {
    text: string;
    className?: string;
    onClick: () => void;
};

export const alertActive = (
    title: string,
    detail?: string,
    confirmButtonText?: string,
    cancelButtonText?: string,
    callback?: () => void,
    icon?: keyof sweetAlertIconType,
    extraButton?: ExtraButton,
    html?: string
) => {
    Swal.fire({
        title: title,
        icon: icon,
        text: detail,
        html,
        cancelButtonText: cancelButtonText || 'ยกเลิก',
        showCancelButton: true,
        confirmButtonColor: colors.complete,
        confirmButtonText: confirmButtonText || 'ตกลง',
        reverseButtons: true,
        customClass: {
            popup: 'custom-alert-sweet',
            icon: 'no-border',
            confirmButton: "custom-alert-active-confirm-button",
            cancelButton: "custom-alert-cancel-button",
            title: "custom-alert-title",
            actions: "custom-alert-actions",
        },
        iconHtml: `<img width="150" height="150" src="${alertIcons.activeAlert}" alt="alert-success" />`,
        footer: extraButton
            ? `<button id="extra-button" class="${extraButton.className || 'extra-btn-default'}">${extraButton.text}</button>`
            : undefined,
        didOpen: () => {
            if (extraButton) {
                const btn = document.getElementById("extra-button");
                if (btn) {
                    btn.addEventListener("click", () => {
                        Swal.close(); // ปิด alert ถ้าต้องการ
                        extraButton.onClick();
                    });
                }
            }
        }
    }).then((result) => {
        if (result.isConfirmed) {
            callback && callback();
        }
        return false;
    });
};
export function swalError(title?: string, detail?: string) {
    Swal.fire({
        icon: 'error',
        title: title,
        text: detail,
        confirmButtonText: 'ตกลง',
        confirmButtonColor: colors.danger
    })
}

export function swalConfirm(title: string, text: string, confirmCallback: () => void, cancelCallback?: () => void) {
    Swal.fire({
        title: title,
        text: text,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: colors.themeMainColor,
        cancelButtonColor: colors.danger,
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
    }).then((result) => {
        if (result.isConfirmed) {
            confirmCallback();
        } else if (cancelCallback) {
            cancelCallback();
        }
    });
}

export function swalActive(title?: string, text?: any, callback?: any, icon?: null | 'info' | 'warning' | 'question', confirmButtonText?: string) {
    Swal.fire({
        title: title,
        // text: text,
        html: text,
        icon: icon || 'success',
        showCloseButton: true,
        showCancelButton: true,
        reverseButtons: true,
        focusConfirm: false,
        confirmButtonText: confirmButtonText || 'ส่งพิจารณา ',
        confirmButtonColor: colors.themeMainColor,
        cancelButtonText: 'ยกเลิก',
        customClass: {
            container: 'swal2-warning'
        }
    }).then((confirm) => {
        if (confirm.isConfirmed) {
            return callback(true)
        }
        return;
    })
}

export function swalSuccessAndNavigate(title: string, confirmCallback: () => void, cancelCallback?: () => void) {
    Swal.fire({
        title: title,
        icon: 'success',
        showCancelButton: true,
        confirmButtonColor: colors.themeMainColor,
        cancelButtonColor: colors.themeSecondColor,
        confirmButtonText: 'ไปที่หน้าตาราง',
        cancelButtonText: 'อยู่หน้านี้ต่อ'
    }).then((result) => {
        if (result.isConfirmed) {
            confirmCallback();
        } else if (cancelCallback) {
            cancelCallback();
        }
    });
}